export var setLanguageCodeInURL = function (currentLanguage, newLanguage) {
    if (newLanguage !== currentLanguage) {
        var currentURL = window.location.pathname;
        var params = window.location.search;
        var fullURL = "".concat(currentURL).concat(params);
        var newURL = fullURL.replace("/".concat(currentLanguage), "/".concat(newLanguage));
        window.history.replaceState(null, '', newURL);
    }
};
